import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import SimpleBar from "simplebar-react";
import { toast } from 'react-toastify';
import { topCategories } from "../../common/data";

//import images
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import product2 from "../../assets/images/products/img-2.png";
import product10 from "../../assets/images/products/img-10.png";

const RecentActivity = ({ rightColumn, hideRightColumn, data = [] }) => {
  // Use props data instead of making API calls
  const reviewsData = data;

  if (!rightColumn) return null;

  return (
    <div className="col-auto layout-rightside-col" id="layout-rightside-coll">
      <div className="overlay" onClick={hideRightColumn}></div>
      <div className="layout-rightside">
        <Card className="h-100 rounded-0">
          <CardBody className="p-0">
            <div className="p-3">
              <h6 className="text-muted mb-0 text-uppercase fw-semibold">
                Recent Activity
              </h6>
            </div>
            <SimpleBar style={{ maxHeight: "410px" }} className="p-3 pt-0">
              <div className="acitivity-timeline acitivity-main">
                {loading ? (
                  <div className="text-center">Loading...</div>
                ) : reviewsData.length > 0 ? (
                  reviewsData.map((item, index) => (
                    <div key={index} className="acitivity-item py-3 d-flex">
                      <div className="flex-shrink-0 avatar-xs acitivity-avatar">
                        <div className="avatar-title bg-danger-subtle text-danger rounded-circle">
                          <i className="ri-stack-fill"></i>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h6 className="mb-1">
                          {item.title || "Activity Update"}
                        </h6>
                        <p className="text-muted mb-1">{item.description}</p>
                        <small className="mb-0 text-muted">
                          {item.timestamp || "Recent"}
                        </small>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center text-muted">No recent activity</div>
                )}

                {/* Static content for demo purposes */}
                <div className="acitivity-item py-3 d-flex">
                  <div className="flex-shrink-0">
                    <img
                      src={avatar2}
                      alt=""
                      className="avatar-xs rounded-circle acitivity-avatar"
                    />
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <h6 className="mb-1 lh-base">
                      Natasha Carey have liked the products
                    </h6>
                    <p className="text-muted mb-1">
                      Allow users to like products in your WooCommerce store.
                    </p>
                    <small className="mb-0 text-muted">25 Dec, 2021</small>
                  </div>
                </div>
                
                {/* Add more static items here */}
              </div>
            </SimpleBar>

            <div className="p-3 mt-2">
              <h6 className="text-muted mb-3 text-uppercase fw-semibold">
                Top 10 Categories
              </h6>
              <ol className="ps-3 text-muted">
                {(topCategories || []).map((item, key) => (
                  <li className="py-1" key={key}>
                    <Link to="#" className="text-muted">
                      {item.category}{" "}
                      <span className="float-end">({item.total})</span>
                    </Link>
                  </li>
                ))}
              </ol>
              <div className="mt-3 text-center">
                <Link to="#" className="text-muted text-decoration-underline">
                  View all Categories
                </Link>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default RecentActivity;